import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { GenericService } from "../../../../../_services/generic-service";


@Injectable()
export class Utente_testService extends GenericService {

    constructor(http: HttpClient) {
        super(http, "Utente_testAF");
    }


    getAllByTest(idTest: string) {
        return this.http.get<any>(this.urlServer + "utentiTest/" + idTest, this.jwt())
            .toPromise()
            .then(res => <any>res)
    }


}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/_service/Utente_testService.ts